module.exports = __webpack_public_path__ + "static/media/arrow.d5e58f9e.svg";